import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import Avatar from 'material-ui/Avatar';
import {ListItem} from 'material-ui/List';
import muiThemeable from 'material-ui/styles/muiThemeable';
import Place from 'material-ui/svg-icons/maps/place';
import DOMPurify from "dompurify";
import {REPORT_PAGE} from "../../../constants/routes";
import {reportStates, stateColors, stateTextColors} from '../../../constants/reports'


class ReportItem extends React.Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
        report: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
    };


    // Render

    renderStatusAvatar() {
        let avatarIcon = <Place color={stateTextColors[reportStates.indexOf(this.props.report.state)]}/>;
        return <Avatar backgroundColor={stateColors[reportStates.indexOf(this.props.report.state)]}>
            {this.props.report.latitude ? avatarIcon : ''}
        </Avatar>

    }

    render() {
        const {report} = this.props;
        const isRichText = report.description
            && report.description.startsWith('<');
        return (
            <Link
                to={REPORT_PAGE.replace(':appId', this.props.app.id).replace(':reportId', this.props.report.id)}>
                <ListItem
                    insetChildren={true}
                    leftAvatar={this.renderStatusAvatar()}
                    primaryText={report.title || this.props.t('module.report.report_no_title')/* TODO : Utilisation de t*/}
                    secondaryText={
                        isRichText ?
                            <div
                                dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(report.description)}}
                            />
                            : report.description
                    }
                    secondaryTextLines={isRichText ? 2 : 1}
                    disableKeyboardFocus={true}
                >
                    {/* TODO : En attente Material ui >=1.0
                    <ListItemSecondaryAction>
                        <Checkbox
                            checkedIcon={<ActionFavorite/>}
                            uncheckedIcon={<ActionFavoriteBorder/>}
                            checked={this.props.point.is_favorite}
                            onCheck={this.onSwitchFavorite()}
                        />
                    </ListItemSecondaryAction> */}
                </ListItem>
            </Link>
        );
    }
}

export default muiThemeable()(ReportItem);



// WEBPACK FOOTER //
// src/components/report/Report/ReportItem.js